import { returnToNativeShell } from '../core/nativeShell.js';

require('../gh_elements/table/gh_table.js');
require('./../auth/gh_auth_form.js');
require('../gh_elements/duration/gh_duration.scss');
require('./user_settings.scss');
require('./group_sharing/groups_table/groupsTable.directive.js');
require('./mcp_servers/mcpServers.directive.js');
require('./agents/agents.directive.js');
require('./deployments/deployments.directive.js');
require('./voip_telephony/sip_trunks/sipTrunks.directive.js');
require('./email_settings/emailSettings.directive.js');
require('./repositories/repositories.directive.js');
require('./apps_list/appsList.directive.js');
require('./integrations/integrations.directive.js');
require('./automations/gh_element/element_automation.directive.js');
require('./automations/api/api_automation.directive.js');
require('./automations/trigger/trigger_automation.directive.js');
require('./automations/task/task_automation.directive.js');
require('../gh_elements/recycle_bin/recycle_bin.js');
require('../core/localizationService/localizationService.js');
require('../core/delete_user_api.js');

angular.module('userSettingsMod', [
	'ghAuthFormModule',
  'mcpServersTableModule',
  'agentsTableModule',
  'deploymentsTableModule',
  'sipTrunksTableModule',
  'emailSettingsModule',
  'reposTableModule',
  'localizationModule',
  'deleteUserApiModule'
])

/*--------------------- USER SETTINGS CONTROLLER --------------------                                */
.controller('userSettingsCtrl', ['$location', '$scope', 'cnfg', '$templateCache', 'storage', 'localizationService', 'authService', 'authApi', '$window', function($location, $scope, cnfg, $templateCache, storage, localizationService, authService, authApi, $window) {
	const dictionary = localizationService.getDictionary('account_settings');
	const translate = (word) => localizationService.translate(word, dictionary);

	$scope.translate = translate;

	$scope.logout = function() {
		authService.getToken().then(function(accessToken) {
			return authApi.logout(accessToken);
		}).then(function() {
			$window.localStorage.clear();
			storage.unsetUser();
			storage.unsetApps();
			gudhub.appProcessor.clearAppProcessor();

			if (returnToNativeShell()) return;

			window.location.replace(cnfg.file_server_url + '/login');
			$scope.$apply();
		});
	};

	$scope.settings_list = [
		{
			title: translate('Account settings'),
			name: 'account',
			icon: 'user_round'
		},{
			title: translate('Groups'),
			name: 'groups',
			icon: 'group'
		},{
      title: translate('MCP Servers'),
      name: 'mcp',
      icon: 'mcp'
    },{
      title: translate('Agents'),
      name: 'agents',
      icon: 'emploee'
    },{
      title: translate('Repositories'),
      name: 'repositories',
      icon: 'code'
    },{
      title: translate('Deployments'),
      name: 'deployments',
      icon: 'rocket'
    },{
      title: translate('VOIP Telephony'),
      name: 'sip_trunks',
      icon: 'phone'
    },{
      title: translate('Email'),
      name: 'email_settings',
      icon: 'email'
    },{
			title: translate('Applications'),
			name: 'applications',
			icon: 'apps'
		},{
			title: translate('Integrations'),
			name: 'integrations',
			icon: 'integrations'
		},
		{
			title: translate('Automations'),
			name: 'automations',
			icon: 'automation'
		},{
			title: translate('Recycle Bin'),
			name: 'recycle_bin',
			icon: 'recycle_bin'
		}].filter(function(setting) {
			var agentFeatureSettings = ['agents', 'repositories', 'deployments'];
			return agentFeatureSettings.indexOf(setting.name) === -1 || cnfg.agent_feature_active;
		});

		$scope.current_settings = null;
		$scope.mobileDetailOpen = false;
		$scope.nav = { onBack: null, title: null };

		$scope.selectSetting = function(current_index){
			$scope.current_settings = $scope.settings_list[current_index];
			$scope.mobileDetailOpen = true;
			$scope.nav.onBack = null;
			$scope.nav.title = null;
		};

		$scope.goBack = function(){
			if ($scope.nav.onBack) {
				$scope.nav.onBack();
			} else {
				$scope.mobileDetailOpen = false;
			}
		};

		$scope.current_settings = $scope.settings_list[0];

}]);

require('./account/userAccount.controller.js');
require('./account/userEmail.controller.js');
require('./account/userPass.controller.js');
require('./group_sharing/groupSharing.controller.js');
require('./apps_list/applications.controller.js');
require('./integrations/integrations.controller.js');
require('./automations/automations.controller.js');
require('./recycle_bin/recycleBin.controller.js');
require('./mcp_servers/mcpServers.controller.js');
require('./agents/agents.controller.js');
require('./deployments/deployments.controller.js');
require('./voip_telephony/sip_trunks/sipTrunks.controller.js');
require('./email_settings/emailSettings.controller.js');
require('./repositories/repositories.controller.js');
